<template>
  <v-container>
    <div class="page">
        <div class="section-title">{{video.head}}</div>
        <p class="section-description">{{video.description}}</p>
        <div v-for="(item, index) in video.items" :key="index">
          <div class="section-second-title">{{ item.title }}</div>
          <div v-if="item.hasSubItems">
            <v-divider class="line-long"></v-divider>
            <div v-for="(sub, index) in item.subItems" :key="index">
              <div class="item-context">
                <div class="item-col-1">
                  {{sub.title}}<span v-if="sub.description">: {{sub.description}}</span>
                </div>
                <a
                  :href="sub.flag ? sub.youTubeLink : 'javascript:void(0)'"
                  :class="{ 'disabled-link': !sub.flag }"
                  :target="sub.flag ? '_blank' : ''"
                  @click="sub.flag ? null : $event.preventDefault()">
                  <v-img class="img" :src="YouTube" alt="YouTube" />
                </a>
                <a
                  :href="sub.flag ? sub.bilibiliLink : 'javascript:void(0)'"
                  :class="{ 'disabled-link': !sub.flag }"
                  :target="sub.flag ? '_blank' : ''"
                  @click="sub.flag ? null : $event.preventDefault()">
                  <v-img class="img" :src="Bilibili" alt="Bilibili" />
                </a>
                <v-btn
                  v-if="sub.downloadVideoName"
                  :disabled="!(sub.flag || sub.downloadEnabled)"
                  variant="tonal"
                  color="info"
                  class="mr-2"
                  size="x-small"
                  @click="download_video(sub.downloadVideoName)">
                  Download
                </v-btn>
                </div>
              <v-divider class="line-long"></v-divider>
            </div>
          </div>
        </div>
    </div>
  </v-container>
</template>

<script>
import YouTube from '@/assets/YouTube.png';
import Bilibili from '@/assets/Bilibili.png';
import { getDownloadUrl } from '@/config'

export default {

  data() {
    return {
      YouTube,
      Bilibili,
      video: {
      head: 'Video',
      description: 'Users can download the video instructions using the following module links or watch them on YouTube or Bilibili website',
      items: [{
        title: 'Overall instruction',
        hasSubItems: true,
        subItems: [{
          title: 'Overall instruction',
          youTubeLink: 'https://youtu.be/LqgE3o4d3m8',
          bilibiliLink: 'https://www.bilibili.com/video/BV1navwepEAu/?vd_source=89a265bac1a824ccf1c546a34779deda',
          flag: true
        }],
      }, {
        title: 'E-BIO',
        hasSubItems: true,
        subItems: [{
          title: 'EBio',
          description: 'explore the biological explanation',
          downloadVideoName: 'ebio_video.zip',
          youTubeLink: 'https://youtu.be/Y0Q9DC8PZzo',
          bilibiliLink: 'https://www.bilibili.com/video/BV1D1hDeAEbD/?spm_id_from=333.1007.top_right_bar_window_history.content.click&vd_source=89a265bac1a824ccf1c546a34779deda',
          flag: true
        }]
      },{
        title: 'E-DB',
        hasSubItems: true,
        subItems: [{
          title: 'EDb',
          description: 'database for support the ExposomeX platform',
          downloadVideoName: 'edb_video.zip',
          youTubeLink: 'https://www.youtube.com/watch?v=B9DZyP5IJr8',
          bilibiliLink: 'https://www.bilibili.com/video/BV1orhReHEAZ/?vd_source=89a265bac1a824ccf1c546a34779deda',
          flag: true
        }]
      },{
        title: 'E-VIZ',
        hasSubItems: true,
        subItems: [{
          title: 'EViz',
          description: 'visualize the data',
          downloadVideoName: 'eviz_video.zip',
          downloadEnabled: true,
          youTubeLink: 'https://youtu.be/si7XErBWkeY',
          bilibiliLink: 'https://www.bilibili.com/video/BV1QChDeeEww/',
        }]
      },{
        title: 'E-META',
        hasSubItems: true,
        subItems: [{
          title: 'EMeta',
          description: 'provide the summary and re-analysis of previous studies',
          downloadVideoName: 'EMeta.rar',
          youTubeLink: 'https://youtu.be/UWGtCVYkEFg',
          bilibiliLink: 'https://www.bilibili.com/video/BV1QDhReLEeh/',
        }]
      },{
        title: 'E-MS',
        hasSubItems: true,
        subItems: [{
          title: 'EMS',
          description: 'analyze the non-targeted analysis data from HRMS',
          downloadVideoName: 'EMS.rar',
          youTubeLink: 'https://youtu.be/lFIdrnf5g6Q',
          bilibiliLink: 'https://www.bilibili.com/video/BV1QChDeeE1n/',
        }]
      },{
        title: 'E-STAT',
        hasSubItems: true,
        subItems: [{
          title: 'StatTidy',
          description: 'tidying data',
          downloadVideoName: 'StatTidy.rar',
          youTubeLink: 'https://youtu.be/kh3czwm_33o',
          bilibiliLink: 'https://www.bilibili.com/video/BV1gUhDewETx/',
        },{
          title: 'StatCros',
          description: 'analyze the cross-sectional data',
          downloadVideoName: 'StatCros.rar',
          youTubeLink: 'https://youtu.be/dXTDvEFdZR8',
          bilibiliLink: 'https://www.bilibili.com/video/BV1QChDeeEGM/',
        },{
          title: 'StatMO',
          description: 'analyze the data of multi-omics',
          downloadVideoName: 'StatMO.rar',
          youTubeLink: '',
          bilibiliLink: 'https://www.bilibili.com/video/BV1SUhDecEVT/',
        },
        {
          title: 'StatPanel',
          description: 'analyze the data of panel study',
          downloadVideoName: 'StatPanel.rar',
          youTubeLink: '',
          bilibiliLink: 'https://www.bilibili.com/video/BV1uUhDewEJa/',
        },{
          title: 'StatSurv',
          description: 'analyze the censored data',
          downloadVideoName: 'StatSurv.rar',
          youTubeLink: '',
          bilibiliLink: 'https://www.bilibili.com/video/BV1uUhDewEBk/',
        },{
          title: 'StatMedt',
          description: 'screen the mediation pathway',
          downloadVideoName: 'StatMedt.rar',
          youTubeLink: '',
          bilibiliLink: 'https://www.bilibili.com/video/BV1fihReREX4/',
        },{
          title: 'StatMix',
          description: 'analyze the effect of mixture exposure',
          downloadVideoName: 'StatMix.rar',
          youTubeLink: '',
          bilibiliLink: 'https://www.bilibili.com/video/BV1SUhDecEKX/',
        },{
          title: 'StatHEP',
          description: 'predict human chemical exposure',
          downloadVideoName: 'StatHEP.rar',
          youTubeLink: 'https://youtu.be/WdHT16WY9BA',
          bilibiliLink: 'https://www.bilibili.com/video/BV1fihReREpe/',
        },{
          title: 'StatIP',
          description: 'explore the statistical explanation',
          downloadVideoName: 'StatIP.rar',
          youTubeLink: 'https://youtu.be/5xBk5c_WC7w',
          bilibiliLink: 'https://www.bilibili.com/video/BV1ZihReREST/',
        }]
      }]
      }
    };
  },
  methods: {
    async download_video(name) {
      let a = document.createElement('a')
      a.href = getDownloadUrl('video', name)
      a.target='_blank'
      a.click()
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  font-size: $webpage-base-font-size;
  margin-left: 2em;
}
p {
  text-indent: 0;
  text-align: left;
}
.section-title {
  font-size: $webpage-large-font-size;
  font-weight: bold;
  line-height: 1.4;
}
.section-second-title {
  font-weight: bold;
  margin: 0.6em 0 0.2em;
}
.section-description {
  margin-bottom: 0.8em;
}
.img {
  height: 20px;
  width: 50px;
}
.item-context {
  display: flex;
  gap: 60px;
  align-items: center;
  line-height: 1.6;
  margin: 0.2em 0;
  justify-content: start;
}
.item-col-1 {
  min-width: 560px;
}
.line-long {
  width: 90%;
}
.disabled-link {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: all !important;
}
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .line-long {
    width: 100%;
  }
  .item-col-1 {
    min-width: 0;
  }
  .item-context {
    justify-content: space-between;
  }
}
@media screen and (max-width: 600px) {
  .page {
    margin: 0;
  }
  .line-long {
    width: 100%;
  }
  .item-context {
    display: flex;
    gap: 5px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: start;
  }
  .item-col-1 {
    min-width: 0;
  }
}

</style>
